import { gql, TypedDocumentNode } from '@apollo/client';

export const VALIDATE_REFERRAL_CODE: TypedDocumentNode<{ referrer: string }, { referrenceCode: string }> = gql`
  query ValidateReferrerCode($referrenceCode: String!) {
    referrer: getReferrerName(referrenceCode: $referrenceCode)
  }
`;
